import ApiService from "@/common/api.service";
import { FETCH_COMPANIES } from "@/store/actions.type";
import { SET_COMPANIES } from "@/store/mutations.type";

const state = {
  companies: []
};

const getters = {
  companies(state) {
    return state.companies;
  }
};

const mutations = {
  [SET_COMPANIES](state, companies) {
    state.companies = companies;
  }
};

const actions = {
  [FETCH_COMPANIES](context, filters) {
    return ApiService.post("/admin/companies", filters).then(companies => {
      context.commit(SET_COMPANIES, companies);
    });
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
